import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import Model from "@tripian/model";
import { api } from "@tripian/core";
import { saveNotification } from "../redux/action/user";

const useCities = () => {
  const [loadingCities, setLoadingCities] = useState<boolean>(true);
  const [cities, setCities] = useState<Model.City[]>();

  const dispatch = useDispatch();

  const fetchCities = useCallback(() => {
    setLoadingCities(true);
    return api
      .citiesAll()
      .then((citiesAllData: Model.City[]) => {
        setCities(citiesAllData);
        return citiesAllData;
      })
      .catch(citiesAllError => {
        dispatch(
          saveNotification(
            Model.NOTIFICATION_TYPE.ERROR,
            "citiesAll",
            "Fetch Cities",
            citiesAllError
          )
        );
        throw citiesAllError;
      })
      .finally(() => {
        setLoadingCities(false);
      });
  }, [dispatch]);

  useEffect(() => {
    fetchCities();
  }, [fetchCities]);

  // Re-fetch when the app language changes — citiesAll() is cached per-lang
  // server-side, but this hook otherwise only ever fetches once on mount.
  useEffect(() => {
    const handleLanguageChange = () => {
      fetchCities();
    };
    window.addEventListener("languageChanged", handleLanguageChange);
    return () =>
      window.removeEventListener("languageChanged", handleLanguageChange);
  }, [fetchCities]);

  return { loadingCities, cities };
};

export default useCities;
